module.exports = __webpack_public_path__ + "img/lawschool-h-474x356.b07484ba.jpg";